import React, { useState } from 'react';
import { Popover, Box } from '@mui/material';
import { Topic as TopicIcon } from '@mui/icons-material';
import Topic from '../topics/Topic';
import CustomChip from './CustomChip';

const TopicsList = ({ topics }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'topics-list' : undefined;

    const topicsLabel = topics.length === 1 ? topics[0].name : `${topics.length} Topics`;

    if (topics.length === 0) {
        return null;
    }

    if (topics.length === 1) {
        return (
            <Topic
                name={topics[0].name}
                colour={topics[0].colour}
            />
        );
    }

    return (
        <>
            <CustomChip
                label={topicsLabel}
                icon={<TopicIcon fontSize="inherit" />}
                onClick={event => setAnchorEl(event.currentTarget)}
                isMenu={true}
            />
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
            >
                <Box
                    sx={{
                        width: 400,
                        display: 'flex',
                        flexWrap: 'wrap',
                        p: 1
                    }}
                    id="topics-list"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={() => setAnchorEl(null)}
                >
                    {topics.map(e => (
                        <Box
                            key={e.id}
                            sx={{ p: 0.5, display: 'flex' }}
                        >
                            <Topic
                                name={e.name}
                                colour={e.colour}
                            />
                        </Box>
                    ))}
                </Box>
            </Popover>
        </>
    );
};

export default TopicsList;